import axios from "axios";

/**
 * The function `syncCartRemote` is an asynchronous function that sends a POST request to a remote
 * server to update the user's cart data.
 * @param data - The `data` parameter is the payload that you want to send to the server. It contains
 * the information about the items in the cart that you want to synchronize remotely.
 * @param userId - The `userId` parameter is the unique identifier of the customer whose cart is being
 * synced. It is used to construct the URL for the API endpoint where the cart data will be sent.
 * @returns the response from the axios post request.
 */
export const syncCartRemote = async (data, userId) => {
  const url = `${routes.back_url_cart}/customers/${userId}/cart`;
  try {
    const response = await axios.post(url, data);
    return response;
  } catch (error) {
    // eslint-disable-next-line no-undef
    console.error(`Error: ${error.message}`);
  }
}

/**
 * The function `clearCartRemote` clears the cart for a specific customer by making a POST request to
 * the server.
 * @returns the response from the axios post request.
 */
export const clearCartRemote = async () => {
  try {
    if (!CUSTOMER_ID) return;
    const customerId = CUSTOMER_ID;
    const response = await axios.post(`${routes.back_url_cart}/customers/${customerId}/cart/clear`);
    return response;
  } catch (error) {
    // eslint-disable-next-line no-undef
    console.error(`Error: ${error.message}`);
  }
}

/**
 * The `updateSyncCart` function updates the user's cart by retrieving the cart items, formatting the
 * data, and syncing it remotely.
 * @returns Nothing is being returned from this function.
 */
export const updateSyncCart = async () => {
  if (!CUSTOMER_ID) return;

  const userEmail = CUSTOMER_EMAIL;
  const userId = CUSTOMER_ID;
  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleDateString("en-US", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
  const { data: { items } } = await axios.get(`${shopUrl}/cart.js`);

  const itemsCurrent = items.map((item) => (
    {
      productTitle: item.product_title,
      variantTitle: `${item.variant_title}`,
      variantId: item.variant_id,
      quantity: item.quantity,
    }
  ))

  const data = {
    email: userEmail,
    updateAt: formattedDate,
    items: itemsCurrent,
  }

  await syncCartRemote(data, userId);
}
